import React, { useEffect, useState } from 'react';
import * as API from '../../framework/API/api';
import { ADS_TYPE, ENTITYNAME, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import BossDialog from '../../components/BossDialog';
import { META_GENDERS } from './SocialMediaConstant';
import { EditPageHeader } from '../../components/EditPageHeader';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import MetaAudienceForm from './Meta/MetaAudienceForm';
import ToastNotification from "../../components/ToastNotification";

const SMAudienceEditForm = (props) => {

    const { item, cancelEdit, refresh, onSave } = props;

    const lang = useTranslation();
    const [dataItem, setDataItem] = useState({
        ...item,
        channel: item?.channel ?? {},
        name: item?.name ?? '',
        description: item?.description ?? '',
        age_min: item?.age_min ?? 0,
        age_max: item?.age_max ?? 0,
        special_ad_categories: item?.special_ad_categories && item?.special_ad_categories.length > 0 ? item?.special_ad_categories.map((x) => ({ _id: x, description: x })) : [],
        genders: item?.genders && item?.genders.length > 0 ? item?.genders.map((x) => ({ _id: x, description: utility.getKeyByValue(META_GENDERS, x) })) : [],
        geo_locations: item?.geo_locations ?? [],
        interests: item?.interests ?? [],
        Archive: item?.Archive ?? false,
    });

    const [channels, setChannels] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.SM_Channels);
        setChannels(channelRes.data);
        if (!item?._id) setDataItem({ ...dataItem, channel: utility.getDefaultItem(channelRes.data) })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        if (name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [name]: value });
        }
    };

    const isValid = () => {
        if (!dataItem.name || dataItem.name === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (dataItem?.channel?.adType === ADS_TYPE.META) {
            if (!dataItem.description || dataItem.description === "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
                return false;
            }
            if (!dataItem.geo_locations || dataItem.geo_locations.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_geo_location_error_message });
                return false;
            }
            if (!dataItem.interests || dataItem.interests.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_interest_error_message });
                return false;
            }
            if (!dataItem.genders || dataItem.genders.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_gender_error_message });
                return false;
            }
            if (!dataItem.age_min || dataItem.age_min === "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_minimum_age_error_message });
                return false;
            }
            if (!dataItem.age_max || dataItem.age_max === "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_maximum_age_error_message });
                return false;
            }
            if (dataItem.age_min > dataItem.age_max) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.maximum_age_should_be_greater_than_minimum_age_error_message }); 
                return false;
            }
        }
        return true;
    }

    const getFinalDataBasedOnChannel = (adType) => {
        switch (adType) {
            case ADS_TYPE.META:
                return {
                    geo_locations: dataItem?.geo_locations && dataItem?.geo_locations.length > 0 ? dataItem.geo_locations : [],
                    interests: dataItem?.interests && dataItem?.interests.length > 0 ? dataItem.interests.map(interest => ({ id: interest.id, name: interest.name.replace(/\(.*$/, '').trim() })) : [],
                    special_ad_categories: dataItem?.special_ad_categories && dataItem?.special_ad_categories.length > 0 ? dataItem.special_ad_categories.map((x) => { return x.description }) : [],
                    age_min: dataItem?.age_min ? parseFloat(dataItem?.age_min) : 0,
                    age_max: dataItem?.age_max ? parseFloat(dataItem?.age_max) : 0,
                    genders: dataItem?.genders && dataItem?.genders.length > 0 ? dataItem.genders.map((x) => { return x._id }) : [],
                };
            default:
                return {};
        }
    }

    const handleSubmit = async (e) => {
        if (!isValid()) return;
        let finalData = {
            _id: dataItem?._id ?? null,
            name: dataItem?.name ?? "",
            description: dataItem?.description ?? "",
            channel: dataItem?.channel && Object.keys(dataItem?.channel).length > 0 ? { _id: dataItem?.channel?._id, adType: dataItem?.channel?.adType } : {},
            ...getFinalDataBasedOnChannel(dataItem?.channel?.adType),
            Archive: dataItem?.Archive ?? false,
        }
        let res = await API.saveData(ENTITYNAME.SM_Audience, finalData);
        let isNew = !dataItem?._id;
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: isNew ? lang.audience_created_successfully : lang.audience_updated_successfully });
            onSave && onSave({ _id: res.data._id, name: res.data.name });
            utility.deleteLocalStorageItem(ENTITYNAME.SM_Audience);
            cancelEdit && cancelEdit();
            refresh && refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message });
        }
    }

    return (
        <BossDialog title={dataItem._id ? lang.update_audience_header : lang.add_audience_header} width={"950px"} onClose={cancelEdit}>
            <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
            <div className='row mt-2'>
                <div className="col-4">
                    <label htmlFor="name">{lang.name_label} *</label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        className="form-control form-control-sm"
                        value={dataItem.name}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="description">{lang.description_label} *</label>
                    <input
                        type="text"
                        name="description"
                        placeholder="Enter Description"
                        className="form-control form-control-sm"
                        value={dataItem.description}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="channel">{lang.channel_label} *</label>
                    <DropDownList
                        name="channel"
                        textField="adType"
                        dataItemKey="_id"
                        data={channels}
                        value={dataItem.channel}
                        onChange={onChange}
                    />
                </div>
            </div>
            {dataItem.channel?.adType === ADS_TYPE.META && (
                <MetaAudienceForm dataItem={dataItem} onChange={onChange} />
            )}
            <div className='row mt-4'>
                <div className='col-4 ml-2'>
                    <input type="checkbox" name="Archive" checked={dataItem.Archive} onChange={onChange} />
                    <label className='pl-1' >{lang.archive}</label>
                </div>
            </div>
        </BossDialog>
    );
};

export default SMAudienceEditForm;